
export const Heading = {
  title: {
    en: "Supported Currencies",
    zh: "支持的货币",
    ko: "지원되는 통화",
  },
  sub_title: {
    en: "List of supported currency codes and countries",
    zh: "支持的货币代码和国家列表",
    ko: "지원되는 통화 코드 및 국가 목록",
  },
  text: {
    en: "There is only 1 widely known currency we don't offer exchange rate data for due to sanctions & lack of any international trade.",
    ko: "국제 제재와 국제 무역이 전혀 이루어지지 않아 환율 데이터를 제공하지 않는 유명한 통화가 1가지만 있습니다.",
    zh: "由于制裁和缺乏国际贸易，我们仅不提供某一广泛认知的货币的汇率数据。"
  },
  currency_code: {
    en: "Currency Code",
    ko: "통화 코드",
    zh: "货币代码"
  },
  currency_name: {
    en: "Currency Name",
    ko: "통화 이름",
    zh: "货币名称"
  },
  currency_symbol: {
    en: "Currency Symbol",
    ko: "통화 심볼",
    zh: "货币符号"
  },
  country: {
    en: "Country",
    ko: "국가",
    zh: "国家"
  },
  north_korea: {
    name: {
      en: 'north korea', 
      ko: '조선', 
      zh: '朝鲜'
    },
    currency_name: {
      en: 'North Korean won', 
      zh: '朝鲜元', 
      ko: '북한 원'
    },
    currency_symbol: "₩",
  },
  unsupported_currencies: {
    en: "Unsupported Currencies",
    ko: "지원되지 않는 통화",
    zh: "不支持的货币"
  }
}
